import { Sidebar } from 'primereact/sidebar'
import React from 'react'
import { NavLink } from 'react-router-dom'

import { sidebarLinks } from '../../utils/sidebarLinks'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

const MobileSibeBar = ({ openMobileSidebar, setOpenMobileSidebar }) => {
  const { user } = useSelector(state => state?.auth)
  const serviceId = user?.service?.id
  const { t } = useTranslation()

  const filteredLinks = sidebarLinks(t).filter(item =>
    item?.serviceIds?.includes(serviceId)
  )

  const customHeader = (
    <div className='flex align-items-center gap-2'>
      <img
        src='/images/supergit-031.png'
        alt='logo'
        className='h-[50px] w-[50px]'
      />
    </div>
  )
  return (
    <div>
      <Sidebar
        visible={openMobileSidebar}
        header={customHeader}
        onHide={() => setOpenMobileSidebar(false)}
        pt={{
          root: { className: 'w-[300px] rounded !bg-primary' },
          header: {
            className:
              'flex items-center justify-between border-b border-gray-800'
          },
          content: { className: 'px-0' },
          closebutton: { className: '!text-white' }
        }}
      >
        <div className='flex flex-col '>
          {filteredLinks?.map((data, index) => (
            <NavLink
              key={index}
              to={data?.link}
              className='flex flex-row   text-white gap-2 group items-center pe-1 ps-3 py-3 sidebar-navlink'
            >
              <div className='flex border border-white h-[25px] text-white justify-center rounded-full w-[25px] group-hover:bg-white group-hover:!text-primary  items-center'>
                {data?.icon}
              </div>
              <p className='text-[14px] text-white font-[400] group-hover:text-white mt-1'>
                {data?.label}
              </p>
            </NavLink>
          ))}
        </div>
      </Sidebar>
    </div>
  )
}

export default MobileSibeBar
